/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalReauthSubmissionHistoryResponse } from './PalReauthSubmissionHistoryResponse';
import {
    PalReauthSubmissionHistoryResponseFromJSON,
    PalReauthSubmissionHistoryResponseFromJSONTyped,
    PalReauthSubmissionHistoryResponseToJSON,
} from './PalReauthSubmissionHistoryResponse';

/**
 * 
 * @export
 * @interface GetPalReauthSubmissionHistory200Response
 */
export interface GetPalReauthSubmissionHistory200Response {
    /**
     * 
     * @type {PalReauthSubmissionHistoryResponse}
     * @memberof GetPalReauthSubmissionHistory200Response
     */
    data?: PalReauthSubmissionHistoryResponse;
}

/**
 * Check if a given object implements the GetPalReauthSubmissionHistory200Response interface.
 */
export function instanceOfGetPalReauthSubmissionHistory200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetPalReauthSubmissionHistory200ResponseFromJSON(json: any): GetPalReauthSubmissionHistory200Response {
    return GetPalReauthSubmissionHistory200ResponseFromJSONTyped(json, false);
}

export function GetPalReauthSubmissionHistory200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPalReauthSubmissionHistory200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PalReauthSubmissionHistoryResponseFromJSON(json['data']),
    };
}

export function GetPalReauthSubmissionHistory200ResponseToJSON(value?: GetPalReauthSubmissionHistory200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PalReauthSubmissionHistoryResponseToJSON(value.data),
    };
}

